import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import AccountSettings from "@/pages/AccountSettings";
import Dashboard from "@/pages/Dashboard";
import NewEntry from "@/pages/NewEntry";
import Workers from "@/pages/Workers";
import MyLog from "@/pages/MyLog";
import Admin from "@/pages/Admin";
import Reports from "@/pages/Reports";
import FAQ from "@/pages/FAQ";
import Photos from "@/pages/Photos";
import HrPortal from "@/pages/hr/HrPortal";
import HrSign from "@/pages/hr/HrSign";
import HrOnboard from "@/pages/hr/HrOnboard";
import HrLeave from "@/pages/hr/HrLeave";
import HrPayslip from "@/pages/hr/HrPayslip";
import HrDo from "@/pages/hr/HrDo";
import HrPack from "@/pages/hr/HrPack";
import SwiPage from "@/pages/hr/SwiPage";
import PolicyPage from "@/pages/hr/PolicyPage";
import WarningPage from "@/pages/hr/WarningPage";

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-navy font-heading">Loading…</div>;
  if (!user) return <Navigate to="/" replace />;
  if (adminOnly && user.role === "supervisor") return <Navigate to="/dashboard" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/gandlone" element={<Login slug="gandlone" />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/new" element={<Protected><NewEntry /></Protected>} />
            <Route path="/workers" element={<Protected><Workers /></Protected>} />
            <Route path="/mylog" element={<Protected><MyLog /></Protected>} />
            <Route path="/reports" element={<Protected><Reports /></Protected>} />
            <Route path="/photos" element={<Protected><Photos /></Protected>} />
            <Route path="/faq" element={<Protected><FAQ /></Protected>} />
            <Route path="/account" element={<Protected><AccountSettings /></Protected>} />
            <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
            <Route path="/hr" element={<HrPortal />} />
            <Route path="/hr/sign/:token" element={<HrSign />} />
            <Route path="/hr/onboard/:token" element={<HrOnboard />} />
            <Route path="/hr/leave/:token" element={<HrLeave />} />
            <Route path="/hr/payslip/:token" element={<HrPayslip />} />
            <Route path="/hr/do/:token" element={<HrDo />} />
            <Route path="/hr/pack/:token" element={<HrPack />} />
            <Route path="/hr/swi/:token" element={<SwiPage />} />
            <Route path="/hr/policy/:token" element={<PolicyPage />} />
            <Route path="/hr/warning/:token" element={<WarningPage />} />
            <Route path="/:slug" element={<Login />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
